import styled from 'styled-components/macro';
import { bool, node } from 'prop-types';

const Form = styled('form')`
  display: flex;
  justify-content: ${({ align }) => (align ? align : 'flex-start')};
  align-items: flex-end;
  flex-wrap: wrap;
  position: relative;

  > div,
  > div > button,
  > div > ul {
    width: 100%;

    &:not(:first-child) {
      margin-top: 0.5em;
    }

    @media screen and (min-width: 50em) {
      width: auto;
      margin: 0;

      &:not(:first-child) {
        margin-top: 0;
        margin-left: 0.5em;
        margin-right: 0;
      }

      &:only-child,
      &:first-child:not(:last-child) {
        margin-left: ${({ alignRight }) => (alignRight ? 'auto' : 0)};
      }
    }
  }
`;

/** ComponentControls renders a form to manage the layout and event handling of the input elements it contains */
const ComponentControls = ({ children, ...presentational }) => (
  <Form {...presentational} onSubmit={(e) => e.preventDefault()}>
    {children}
  </Form>
);

ComponentControls.defaultProps = {
  alignRight: true,
};

ComponentControls.propTypes = {
  /** Should the children be aligned to the right?*/
  alignRight: bool,
  /** The child elements to be rendered inside ComponentsControl */
  children: node,
};

export default ComponentControls;
